var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPageicon = function SvgPageicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M11.6 12.6a1.4 1.4 0 0 1-1.4 1.4H1.8a1.4 1.4 0 0 1-1.4-1.4V5.068a2.1 2.1 0 0 1 .616-1.484L3.984.616A2.1 2.1 0 0 1 5.468 0H10.2a1.4 1.4 0 0 1 1.4 1.4v11.2Zm-9.8 0h8.4V1.4H6v3.5a.7.7 0 0 1-.7.7H1.8v7Z",
    clipRule: "evenodd"
  })));
};
export default SvgPageicon;